import { Component, Inject } from '@angular/core';
import { Env } from '@usimweb/core/models';

@Component({
    template: '',
    standalone: false
})
export class ColorInjector {
  public mainColor: string = '';
  public headerColor: string = '';
  public environment: Env;

  constructor(@Inject('environment') environment: Env) {
    this.environment = environment;
    this.mainColor = this.environment.mainColor;
    this.headerColor = this.environment.headerColor;
  }
}
